import React from 'react';
import { Feature } from 'core/enums/features';
import { BaseRoute } from 'core/models/base-routes';

export const InternetRoutes: BaseRoute[] = [
  {
    path: '*',
    title: 'All',
    name: 'product.internet.tabs.all',
    feature: Feature.Products,
    component: React.lazy(() => import('./tabs/internet-all')),
    hideFromMainMenu: true,
    icon: 'icon-list',
  },
  {
    path: 'fibre',
    title: 'Fibre',
    name: 'product.internet.tabs.fibre',
    feature: Feature.Products,
    component: React.lazy(() => import('./tabs/internet-fibre')),
    hideFromMainMenu: true,
    isActive: false,
    icon: 'icon-list',
  },
  {
    path: 'flte',
    title: 'FLTE',
    name: 'product.internet.tabs.flte',
    feature: Feature.Products,
    component: React.lazy(() => import('./tabs/internet-flte')),
    hideFromMainMenu: true,
    isActive: false,
    icon: 'icon-list',
  },
  {
    path: 'inactive',
    title: 'Inactive',
    name: 'product.internet.tabs.inactive',
    feature: Feature.Products,
    component: React.lazy(() => import('./tabs/internet-inactive')),
    hideFromMainMenu: true,
    isActive: false,
    icon: 'icon-list',
  },
];